import { useState } from "react";
import { Link, createFileRoute } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { PolygrafLogo } from "@/components/icons/logo";

export const Route = createFileRoute("/compliance-test/")({
  component: RouteComponent,

  head: () => ({
    meta: [
      {
        title:
          "Polygraf AI Governance Assessment | Test Your AI Risk Readiness",
      },
      {
        name: "description",
        content:
          "Take the 3-minute AI Governance Assessment to evaluate your organization's AI risk readiness, security maturity, and compliance posture. Get your free Polygraf AI score.",
      },
    ],
  }),
});

function RouteComponent() {
  const [isConsentChecked, setIsConsentChecked] = useState(false);

  return (
    <div className="dark:bg-blackç flex min-h-screen items-center justify-center bg-slate-100 px-4 py-16">
      <div className="mx-auto flex max-w-3xl flex-col items-center rounded-[32px] border border-slate-200 bg-white px-6 py-14 text-center shadow-sm sm:px-12 dark:border-slate-800 dark:bg-slate-900">
        <PolygrafLogo variant="lg" className="mb-8" />
        <div className="space-y-6">
          <div className="space-y-4">
            <h1 className="text-3xl font-semibold text-slate-900 sm:text-4xl dark:text-white">
              Check Your Organization's AI Risk Level
            </h1>
          </div>
          <div className="space-y-4 text-base text-slate-600 dark:text-slate-300">
            <p>
              A fast, confidential assessment for leaders responsible for data
              and compliance. This short diagnostic helps you evaluate your AI
              governance maturity, employee behavior, and data protection
              readiness.
            </p>
            <p>
              At the end, you'll receive a personalized risk score and a
              compliance readiness report straight to your inbox.
            </p>
          </div>
          <div className="flex items-start gap-3 text-left">
            <Checkbox
              id="consent"
              checked={isConsentChecked}
              onCheckedChange={(checked) =>
                setIsConsentChecked(checked === true)
              }
              className="mt-0.5 size-5 rounded-full border-slate-400 dark:border-slate-500"
            />
            <label
              htmlFor="consent"
              className="cursor-pointer text-sm leading-relaxed text-slate-600 dark:text-slate-300"
            >
              I agree to the use of my personal data in accordance with Polygraf
              Inc.’s{" "}
              <a
                href="https://polygraf.ai/privacy-policy/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#ed2ea0] hover:underline"
              >
                Privacy Policy
              </a>{" "}
              and{" "}
              <a
                href="https://polygraf.ai/terms-and-conditions/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#ed2ea0] hover:underline"
              >
                Terms of Use
              </a>
              . Polygraf Inc. will not sell, trade, lease, or rent your personal
              data to third parties. This site is protected by reCAPTCHA and the{" "}
              {""}
              <a
                href="https://policies.google.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#ed2ea0] hover:underline"
              >
                Google Privacy Policy
              </a>{" "}
              and{" "}
              <a
                href="https://policies.google.com/terms"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#ed2ea0] hover:underline"
              >
                Terms of Service
              </a>
              .
            </label>
          </div>
          <Button
            asChild={isConsentChecked}
            disabled={!isConsentChecked}
            size="lg"
            className="mt-4 rounded-lg bg-[#ed2ea0] px-10 py-6 text-base font-semibold shadow-lg shadow-[#ed2ea0]/30 transition hover:bg-[#d8258f] disabled:cursor-not-allowed disabled:opacity-50 disabled:shadow-none dark:text-white dark:shadow-[#ed2ea0]/50"
          >
            {isConsentChecked ? (
              <Link to="/compliance-test/quiz">Start the Compliance Test</Link>
            ) : (
              "Start the Compliance Test"
            )}
          </Button>
        </div>
      </div>
    </div>
  );
}
